import React from 'react';

/**
 * BrandLogo — stylized golden wings icon for cont.AI.
 *
 * Two mirrored wings, each built from four feather blades, filled with an
 * antique-gold gradient to echo the physical cont.AI wings emblem.
 *
 * @param {Object} props
 * @param {number} [props.size=48] - Rendered height in pixels.
 * @param {string} [props.className] - Additional CSS classes.
 */
function BrandLogo({ size = 48, className = '' }) {
  return (
    <svg
      className={className}
      width={size * (64 / 48)}
      height={size}
      viewBox="0 0 64 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="cont.AI"
    >
      <defs>
        <linearGradient id="contai-gold" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#e9d18f" />
          <stop offset="45%" stopColor="#c9a961" />
          <stop offset="100%" stopColor="#8b7130" />
        </linearGradient>
        <linearGradient id="contai-gold-deep" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#d3b873" />
          <stop offset="100%" stopColor="#7c6529" />
        </linearGradient>
      </defs>

      {/* Right wing — four feather blades sweeping up from the center */}
      <g>
        <path
          d="M33 42 C40.5 39.5 51 33 60 19 C61.5 16.5 60.5 14.5 58 16 C48 22 38 31.5 33 42 Z"
          fill="url(#contai-gold)"
        />
        <path
          d="M33 42 C39 39.5 47 35 53.5 25.5 C54.8 23.5 53.8 21.8 51.8 23 C43.5 28 36.5 34.5 33 42 Z"
          fill="url(#contai-gold-deep)"
          opacity="0.92"
        />
        <path
          d="M33 42 C37.5 40 42.5 36.8 46 31 C47 29.2 46 27.6 44.2 28.7 C39.5 31.8 35 36.5 33 42 Z"
          fill="url(#contai-gold)"
          opacity="0.85"
        />
        <path
          d="M33 42 C35.8 40.4 38.5 38.2 39.9 35.2 C40.6 33.6 39.6 32.5 38.2 33.6 C36 35.4 34.1 38.4 33 42 Z"
          fill="url(#contai-gold-deep)"
          opacity="0.8"
        />
      </g>

      {/* Left wing (mirror) */}
      <g transform="matrix(-1,0,0,1,64,0)">
        <path
          d="M33 42 C40.5 39.5 51 33 60 19 C61.5 16.5 60.5 14.5 58 16 C48 22 38 31.5 33 42 Z"
          fill="url(#contai-gold)"
        />
        <path
          d="M33 42 C39 39.5 47 35 53.5 25.5 C54.8 23.5 53.8 21.8 51.8 23 C43.5 28 36.5 34.5 33 42 Z"
          fill="url(#contai-gold-deep)"
          opacity="0.92"
        />
        <path
          d="M33 42 C37.5 40 42.5 36.8 46 31 C47 29.2 46 27.6 44.2 28.7 C39.5 31.8 35 36.5 33 42 Z"
          fill="url(#contai-gold)"
          opacity="0.85"
        />
        <path
          d="M33 42 C35.8 40.4 38.5 38.2 39.9 35.2 C40.6 33.6 39.6 32.5 38.2 33.6 C36 35.4 34.1 38.4 33 42 Z"
          fill="url(#contai-gold-deep)"
          opacity="0.8"
        />
      </g>
    </svg>
  );
}

export default BrandLogo;
